import { Moment } from "moment";
import {
  CalendarEventType,
  CalendarSetStatus,
  ICalendarConfig,
  ICalendarWorkTemplateBase,
  IServiceArea,
  ITrayConfig,
  IUserResponse,
  PlatformModules,
} from "@miplatform/types";

export interface ICalendarSetData {
  id?: string;
  name: string;
  module: PlatformModules;
  status: CalendarSetStatus;
  eventType: CalendarEventType;
  canScheduleOutsideDayTime: boolean;
  requireManagerOverrideForOutsideDayTime: boolean;
  workTemplateBases: ICalendarWorkTemplateBase[];
  schedulerUsers: IUserResponse[];
  assignableUsers: IUserResponse[];
  trays: ITrayConfig[];
  serviceAreas: IServiceArea[];
  calendarConfigs: ICalendarConfig[];
  dayStartTime?: string | Moment;
  dayEndTime?: string | Moment;
  modifiedOn?: string;
  createdOn?: string;
  workCapacities: {
    [userId: string]: {
      [workBaseTemplateId: string]: ICalendarWorkCapacityConfig;
    };
  };
}

export interface ICalendarSetDuplicateOptions {
  schedulerUsers: boolean;
  assignableUsers: boolean;
  tabsAndTrays: boolean;
  serviceArea: boolean;
}

export interface ICalendarWorkCapacityConfig {
  orderTemplateId: string;
  amount: number;
  displayOrder: number;
}

export enum ConfigCalendarTabs {
  DisplayType = "DisplayType",
  Details = "Details",
  Trays = "Trays",
  WorkTemplateBase = "WorkTemplateBase",
  CalendarUsers = "CalendarUsers",
  AssignableUsers = "AssignableUsers",
  WorkCapacity = "WorkCapacity",
  ServiceArea = "ServiceArea",
  Configs = "CalendarConfigs",
}
